import { createContext } from 'react';

const NotificationStackContext = createContext({
  notifications: [],
  push: (notification) => {},
});

export default NotificationStackContext;
